import { useSetupStore, useCommunicationStore, useTicketStore, useFormEntryStore } from '@/stores';

/**
 * The shared tab set for the "Nachrichten" hub, rendered identically by the
 * communication Inbox and the (nested) Form-entries page so the tab bar never
 * disappears when switching between them.
 *
 * Pass the calling component (for its scoped $t).
 */
export function messageHubTabs(vm) {
    const enabledExtensions = useSetupStore().enabledExtensions;
    const tabs = [];

    // Same counts as the sidebar entries these tabs mirror, so the number is
    // the same wherever the surface is reached from. Both stores keep them live
    // over the CMS broadcast channel.
    const unread = useCommunicationStore().unreadCount;
    const openTickets = useTicketStore().openCount;
    const unreadEntries = useFormEntryStore().unreadCount;

    if (enabledExtensions.includes('communication')) {
        tabs.push({
            name: vm.$t('Conversations'),
            path: '/conversations',
            icon: { name: 'comments', group: 'far' },
            badge: unread > 0 ? unread : undefined,
        });
    }

    if (enabledExtensions.includes('forms')) {
        tabs.push({
            name: vm.$t('Form entries'),
            path: '/form-entries',
            icon: { name: 'edit', group: 'fas' },
            badge: unreadEntries > 0 ? unreadEntries : undefined,
        });
    }

    if (enabledExtensions.includes('tickets')) {
        tabs.push({
            name: vm.$t('Tickets'),
            path: '/tickets',
            icon: { name: 'ticket', group: 'fas' },
            badge: openTickets > 0 ? openTickets : undefined,
        });
    }

    // A single tab is not a tab bar — with only one hub surface enabled the
    // page is a standalone menu entry and renders no tabs at all.
    return tabs.length > 1 ? tabs : [];
}

/** Which hub tab is active for the current route path. */
export function activeMessageHubTab(path) {
    if (path.indexOf('/form-entries') === 0) return '/form-entries';
    if (path.indexOf('/tickets') === 0) return '/tickets';
    return '/conversations';
}
